import http from "../../http-common";

const getAllInvoices = async (query) => {
  return await http.get("/ultimate/invoices", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const processInvoices = async (data) => {
  return await http.post("/ultimate/invoices/process", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

export default {
  getAll: getAllInvoices,
  processInvoices: processInvoices,
};